module.exports = "https://www.gc-pro.gnp.com.mx/8e61276273ae8b0f3b91ceecf2a344cf.svg";


//////////////////
// WEBPACK FOOTER
// ./src/img/info_outline.svg
// module id = 1848
// module chunks = 0